var map = {
	"./activeUsersWidget.vue": 90817,
	"./backgroundJobsWidget.vue": 96528,
	"./newsWidget.vue": 37269,
	"./orderStatsWidget.vue": 36285,
	"./syncQueueWidget.vue": 23204,
	"./testWidget.vue": 5534,
	"./testWidget2.vue": 69234,
	"./welcomeWidget.vue": 23149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;